// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"dc627d10","75":"a24892f9","80":"25f4f068","84":"8a22ddb6","100":"07a5f97d","147":"f7882cb6","536":"045f53d6","602":"7244c461","790":"87b8d7b3","875":"25422ee3"}[chunkId] + ".chunk.css";
};